import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the admin session token
    localStorage.setItem("session_token", "admin_token_1762451209783");
    
    // Redirect to home (which will then redirect to admin dashboard)
    setTimeout(() => {
      window.location.href = "/";
    }, 500);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-indigo-700 font-medium">Logging you in as Admin...</p>
      </div>
    </div>
  );
}
